import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// PWA: registra service worker pra app ser instalável e suportar push
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {});
  });
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
